<template>
  <div>
    <div id="app">
      <router-view />
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import Stickyfill from "stickyfilljs";

export default {
  name: "App",
  data() {
    return {
      width: window.innerWidth,
      // width: window.visualViewport.width
    };
  },
  mounted: function () {
    this.setViewPort();
    // サービスヘッダーposition stickyのIE11対策
    let header = document.querySelectorAll(".header-service");
    Stickyfill.add(header);
  },
  created: function () {
    // インスタンスを作成した後、イベントリスナに登録
    window.addEventListener("resize", debounce(this.setViewPort, 300), false);
  },
  updated: function () {
    // 会員ヘッダーposition stickyのIE11対策
    let header = document.querySelectorAll(".header-member");
    Stickyfill.add(header);
  },
  beforeUnmount: function () {
    // インスタンスを破棄する前に、イベントリスナから削除
    window.removeEventListener("resize", this.setViewPort, false);
  },
  methods: {
    setViewPort() {
      this.width = window.parent.screen.width;
      // this.width = window.innerWidth
      // this.width = window.visualViewport.width
      // console.log('this.width', this.width)
      if (this.width > 767 && this.width < 1241) {
        // タブレットの場合
        document
          .querySelector("meta[name='viewport']")
          .setAttribute(
            "content",
            "width=1240,maximum-scale=1,user-scalable=0"
          );
      } else {
        document
          .querySelector("meta[name='viewport']")
          .setAttribute("content", "width=device-width,initial-scale=1.0");
      }
    },
  },
};
</script>

<style lang="scss">
@import "assets/stylesheets/styles";
@import "assets/stylesheets/normalize";
@import "assets/stylesheets/utilities/spacing";
@import "assets/stylesheets/utilities/text";
@import "assets/stylesheets/utilities/icon";
@import "assets/stylesheets/grid";
@import "assets/stylesheets/common";
</style>
